import React, { useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import { connect } from 'react-redux'

import { setApp, setUdn, clearState } from "../../../redux/actions/generalActions/mainActions";
import { showLoader } from "../../../components/loader/loader";

import NewItem from "../../../components/buttons/newItem";
import VectorList from "./_list";
import VectorForm from "./_form";

const Vector = props => {
    const { viewMode, loading } = props.mainProps

    useEffect(() => {
        const udn = localStorage.getItem('selectedUdn') !== '' ? JSON.parse(localStorage.getItem('selectedUdn')) : null

        if (udn !== null)
            props.setUdn(udn);

        if (props.app !== null)
            props.setApp(props.app);

        return () => {
            props.clearState();
        }
    },[]);

    return (
        <>
            { loading ? showLoader() : null}
            <NewItem />
            <Row>
                <Col>
                    {(
                        function() {
                            switch (viewMode) {
                                case "LIST" :
                                    return <VectorList app={props.app}/>
                                case "FORM" :
                                    return <VectorForm />
                                default:
                                    return null;
                            }
                        })()}
                </Col>
            </Row>
        </>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setUdn,
    setApp
});

export default connect(mapStateToProps, mapActionsToProps)(Vector)